export { DefaultPrivacyLevel, TraceContextInjection, isSampleRate, validateAndBuildConfiguration, serializeConfiguration, } from './configuration';
export { createEndpointBuilder, buildEndpointHost } from './endpointBuilder';
export * from './intakeSites';
export { computeTransportConfiguration, isIntakeUrl } from './transportConfiguration';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum-core/~/@datadog/browser-core/esm/domain/configuration/index.js